document.addEventListener('DOMContentLoaded', () => {
  // 只在小屏幕设备上执行（小于768px）
  if (window.innerWidth >= 889) {
    console.log('大屏设备，不启用折叠功能');
    return;
  }

  console.log('Footer折叠脚本加载');
  const footers = document.querySelectorAll('.joe-footer');

  footers.forEach(footer => {
    const collapses = footer.querySelectorAll('.joe-footer-collapse');
    console.log(`找到${collapses.length}个可折叠区域`);

    if (collapses && collapses.length > 0) {
      const observerOptions = {
        root: null,
        rootMargin: '0px 0px 50px 0px',
        threshold: 0.1
      };
      
      const footerObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            initCollapseToggle(entry.target);
            footerObserver.unobserve(entry.target);
          }
        });
      }, observerOptions);

      collapses.forEach(collapse => {
        footerObserver.observe(collapse);
      });
       
      function initCollapseToggle(collapse) {
        try {
          const contentElement = collapse.querySelector('.joe-footer-block__details-content, .footer-block__details-content');
          if (!contentElement) {
            console.error('未找到内容元素');
            return;
          }
          
          // 确保有过渡样式
          contentElement.style.transition = 'height 0.4s cubic-bezier(0.25, 1, 0.5, 1), opacity 0.4s ease';
          
          // 初始状态设置
          if (contentElement.classList.contains('footer-collapse-hidden')) {
            // 如果默认显示，设置为auto高度
            contentElement.style.height = 'auto';
            const actualHeight = contentElement.scrollHeight;
            console.log('内容实际高度:', actualHeight);
            // 记录实际高度，以便后续动画使用
            contentElement.setAttribute('data-height', actualHeight);
            
            // 初始状态展开，箭头也应该旋转
            const arrowIcon = collapse.querySelector('.text-collapse');
            if (arrowIcon) {
              arrowIcon.classList.add('collapse-svg-rotate');
            }
            const symbol = collapse.querySelector('.text-collapse-symbol');
  if (symbol) {
    symbol.textContent = '−'; // 默认展开时显示减号
  }

  
          } else {
            // 如果默认隐藏，设置高度为0
            // contentElement.style.height = '0px';
            // contentElement.style.overflow = 'hidden';
            contentElement.style.opacity = '0';
            
            // 初始状态收起，确保箭头不旋转
            const arrowIcon = collapse.querySelector('.text-collapse');
            if (arrowIcon) {
              arrowIcon.classList.remove('collapse-svg-rotate');
            }
          }
          
          const header = collapse.querySelector('h2.footer-block__heading.inline-richtext');
          if (!header) {
            console.error('未找到标题元素');
            return;
          }
          
          const arrowIcon = collapse.querySelector('.text-collapse');
          const symbol = collapse.querySelector('.text-collapse-symbol');


          // 添加点击事件
  header.addEventListener('click', () => {
  const isCollapsed = contentElement.classList.contains('footer-collapse-show');


  if (isCollapsed) {
    // —— 收起 -> 展开 ——
    collapse.classList.remove('collapsed'); // 展开时有边框
    // 先用 auto 测一次真实高度
    contentElement.style.removeProperty('height');
    contentElement.style.height = 'auto';
    const styles = getComputedStyle(contentElement);
    const target =
      contentElement.scrollHeight +
      parseFloat(styles.borderTopWidth) +
      parseFloat(styles.borderBottomWidth);

    // 回到 0 作为起点
    // contentElement.style.overflow = 'hidden';
    contentElement.style.opacity  = '0';
    // contentElement.style.height   = '0px';
    // 强制回流
    contentElement.offsetHeight;

    // 开始展开
    contentElement.style.height = target + 'px';
    contentElement.style.opacity = '1';

    contentElement.classList.remove('footer-collapse-show');
    contentElement.classList.add('footer-collapse-hidden');

    // 展开时的 transitionend 回调
const onEndOpen = (e) => {
  if (e.propertyName !== 'height') return;
  contentElement.style.height = 'auto';            // 让高度回归自适应
  contentElement.style.removeProperty('overflow'); // 去掉 overflow:hidden
  contentElement.removeEventListener('transitionend', onEndOpen);
};
contentElement.addEventListener('transitionend', onEndOpen);


    if (arrowIcon) arrowIcon.classList.add('collapse-svg-rotate');
    if (symbol) symbol.textContent = '−';
    header.classList.add('footer-expanded');

  } else {
    // —— 展开 -> 收起 ——
     collapse.classList.add('collapsed'); // 收起时去掉边框
    // 从当前真实高度开始
    const styles = getComputedStyle(contentElement);
    const start =
      contentElement.scrollHeight +
      parseFloat(styles.borderTopWidth) +
      parseFloat(styles.borderBottomWidth);

    contentElement.style.height   = start + 'px';
    // contentElement.style.overflow = 'hidden';
    // 强制回流
    contentElement.offsetHeight;

    // 开始收起
    contentElement.style.height = 'auto';
    contentElement.style.opacity = '0';

    const onEndClose = (e) => {
      if (e.propertyName !== 'height') return;
      // 收起态保留 overflow:hidden；高度清零即可
      contentElement.removeEventListener('transitionend', onEndClose);
    };
    contentElement.addEventListener('transitionend', onEndClose);

    contentElement.classList.remove('footer-collapse-hidden');
    contentElement.classList.add('footer-collapse-show');
    collapse.classList.add('is-collapsed'); 

    if (arrowIcon) arrowIcon.classList.remove('collapse-svg-rotate');
    if (symbol) symbol.textContent = '+';
    header.classList.remove('footer-expanded');
  }
});

          
          // 设置标题样式
          header.style.cursor = 'pointer';
        } catch (error) {
          console.error('初始化折叠区域时出错:', error);
        }
      }
    }
  });


});